/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLeftSmallCuteRe: {
  name: 'left-small-cute-re';
  data: string;
} = {
  name: 'left-small-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.773 8.196c-.176.045-.422.195-.88.537-.911.681-1.775 1.569-2.335 2.401-.373.555-.373 1.177 0 1.732.572.851 1.472 1.768 2.422 2.467.54.398.704.477.995.479.697.005 1.16-.606.966-1.275-.082-.281-.218-.424-.807-.849a9.24 9.24 0 0 1-1.475-1.369L11.393 12l.266-.319a9.24 9.24 0 0 1 1.475-1.369c.589-.425.725-.568.807-.849a.977.977 0 0 0-.247-.999c-.216-.219-.635-.34-.921-.268"/></svg>`
};
